const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/profile/edit/record-hours.$communityId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/profile/edit/record-hours/$communityId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Investment Record",
      description: "Page title for the user investment record page path"
    })
  }
});